<script lang="ts">
    import dayjs from 'dayjs';
    import { onMount } from 'svelte';
    import clockStore from '../../../utils/clock.js';

    // update every 1sec
    const clock = clockStore({ interval: 1000 });

    let startTime;

    onMount(() => {
        startTime = dayjs($clock);
    });
</script>

<div class="time">
    {dayjs.duration(dayjs($clock).diff(startTime)).format('HH:mm:ss')}
</div>
